import { Box, FormControl, Stack, Typography } from '@mui/material'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import { observer } from 'mobx-react-lite'
import CreditCardAliasRow from './CreditCardAliasRow'
import { useEffect, useState } from 'react'
import AddCreditCard from './AddCreditCard'
import { CardHelper } from './CardHelper'
import Errors from 'Components/Elements/Errors/Errors'
import { makeAutoObservable } from 'mobx'
import { isEmpty } from 'lodash'

class StoreCreditCardAlias {
    error = []
    retryCount = 0
    remainingTime = 0
    isInitializing = false

    setRemainingTime = time => {
        this.remainingTime = time
        this.isInitializing = true
    }

    setRetryCount = count => {
        this.retryCount = count
    }
    isNewCard = false

    setError = error => {
        this.error = error
    }
    getError = () => {
        return this.error
    }
    hasError = () => {
        return this.error.length > 0
    }

    setIsNewCard = isNewCard => {
        this.isNewCard = isNewCard
    }
    getIsNewCard = () => {
        return this.isNewCard
    }

    constructor() {
        makeAutoObservable(this)
    }
}

export const storeCreditCardAlias = new StoreCreditCardAlias()

const CreditCardAliasBox = observer(({ savedCreditCards = [], afterAction = () => {} }) => {
    const translate = useTranslate()

    const [selectedCard, setSelectedCard] = useState(null)

    useEffect(() => {
        if (savedCreditCards.length === 0) {
            setSelectedCard('AddCreditCard')
        }
    }, [savedCreditCards])

    useEffect(() => {
        if (selectedCard === 'AddCreditCard') {
            storeCreditCardAlias.setError([])
        }
    }, [selectedCard])

    return (
        <Stack position={'relative'}>
            <FormControl sx={{ gap: '16px' }}>
                <Stack gap={'16px'}>
                    {savedCreditCards.map((card, key) => {
                        if (isEmpty(card.methodDetails.creditCardNumberMasked)) return null
                        return (
                            <CreditCardAliasRow
                                key={CardHelper.getCreditCardAlias(card)}
                                cardAliasNumber={CardHelper.getCreditCardAlias(card)}
                                cardBrand={CardHelper.getCreditCardAlias(card, false)}
                                cardAlias={card.methodDetails.alias}
                                isChecked={selectedCard === `${CardHelper.getCreditCardAlias(card)}-${card.key}`}
                                onChange={() => {
                                    console.log(card)
                                    storeCreditCardAlias.setIsNewCard(false)
                                    setSelectedCard(`${CardHelper.getCreditCardAlias(card)}-${card.key}`)
                                }}
                                afterAction={callback => {
                                    if (callback) {
                                        if (callback.isError) {
                                            storeCreditCardAlias.setError(callback.errorMessages)
                                        } else {
                                            setSelectedCard('AddCreditCard')
                                            afterAction()
                                        }
                                    } else {
                                        afterAction()
                                    }
                                }}
                            />
                        )
                    })}
                </Stack>

                {selectedCard !== 'AddCreditCard' && (
                    <CreditCardAliasRow
                        cardAliasNumber={translate('new_credit_card')}
                        cardBrand="All"
                        isChecked={selectedCard === 'AddCreditCard'}
                        onChange={() => {
                            storeCreditCardAlias.setIsNewCard(true)
                            setSelectedCard('AddCreditCard')
                        }}
                        afterAction={() => {
                            afterAction()
                        }}
                    />
                )}
            </FormControl>
            {selectedCard === 'AddCreditCard' && <AddCreditCard afterAction={afterAction} />}
            {storeCreditCardAlias.hasError() === true && storeCreditCardAlias.getError().length > 0 && (
                <Errors sx={{ mt: '16px' }}>
                    {storeCreditCardAlias.getError().map((item, key) => {
                        return (
                            <Box textAlign={'center'} pl="30px" pr="30px" key={key}>
                                <Typography variant="error">{item}</Typography>
                            </Box>
                        )
                    })}
                </Errors>
            )}
        </Stack>
    )
})

export default CreditCardAliasBox
